import script from "./CreateShareModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateShareModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateShareModal.vue?vue&type=style&index=0&id=712deaa8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712deaa8"]])

export default __exports__